import { isAfter } from 'date-fns'
import React, { Component } from 'react'
import parse from 'html-react-parser';
import { getAttributeCourseStaticInfo } from '../../../helpers/enrolment'
import { deleteChoiceLines, getChoiceLines, putChoiceLines } from '../../../services/vu'
import LoadingWholePage from '../LoadingWholePage'
import ChoiceLineModel from '../Modals/ChoiceLineModel'
import Sidenote from '../Sidenote'

import { helpContactButtonLink, helpLink } from '../../../helpers/links'

class ChoiceLines extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loadingWholePage: false,
      stillProgressingLoading: false,
      openChoiceLineModel: false,
      updatingChoiceLines: false,
      removingChoiceLine: false,
      choiceLineResponse: {},
      selectedChoiceLine: {},
      choiceLineSelections: [],
      displayError: false,
      errorMessage: null,
      triggerReloadChoiceLineParents: false,
      showChoiceLineHelpModel: false
    }
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.reOpenModal && !prevProps.reOpenModal) {
      let structureComponentId = this.state.selectedChoiceLine.structureComponentId
      let choiceLine = this.props.choiceLines.filter(choiceLine => {
        return choiceLine.structureComponentId === structureComponentId
      })[0]
      this.handleChoiceLineModelOpen(choiceLine)
    }
  }

  handleChoiceLineRemoval = choiceLineSelection => {
    this.setState({
      openChoiceLineModel: false,
      removingChoiceLine: true,
      triggerReloadChoiceLineParents: false
    })

    let queryParams = {
      parentStudentStudyPackageNumber: this.state.selectedChoiceLine.parentStudentStudyPackage,
      courseStudyPackageCode: getAttributeCourseStaticInfo('courseCode'),
      courseStudyPackageVersion: getAttributeCourseStaticInfo('versionNumber'),
      courseStudentStudyPackageAttempt: getAttributeCourseStaticInfo('attemptNumber'),
      unitStudyPackageCode: choiceLineSelection.studyPackageCode,
      unitStudyPackageVersion: choiceLineSelection.studyPackageVersion,
      unitStudentStudyPackageAttempt: choiceLineSelection.studentStudyPackageAttempt
    }

    deleteChoiceLines(queryParams)
      .then(response => {
        this.setState({
          removingChoiceLine: false,
          displayError: false
        })
        this.props.reloadChoiceLineParents(true)
      })
      .catch(reason => {
        let link = React.createElement('a', { href: 'https://www.vu.edu.au/course-unit-advice' }, 'contact your Course and Unit Advisor')
        let errorMessage = choiceLineSelection.canWithdraw
          ? React.createElement(
              'div',
              {},
              'You can’t change this selection because you are currently enrolled in this unit. Please withdraw from the unit and then try again, or ',
              link,
              ' to discuss changing this selection.'
            )
          : React.createElement('div', {}, 'You can’t change this selection in MyVU. Please contact your ', link, ' to discuss changing this selection.')

        if (reason.status === 504) {
          link = React.createElement('a', { href: 'https://www.vu.edu.au/contact-us/vuhq-student-service-centres' }, 'contact VUHQ.')
          errorMessage = React.createElement('div', {}, 'There was an error removing your selection. Please try again. If the problem persists, please ', link)
        }
        this.setState({
          openChoiceLineModel: true,
          displayError: true,
          errorMessage: errorMessage,
          removingChoiceLine: false,
          triggerReloadChoiceLineParents: true
        })
      })
  }

  scheduleStudentOneTimeoutCall = (endDTime, submitSelections, putResponse) => {
    setTimeout(() => {
      this.handleStudentOneTimeout(endDTime, submitSelections, putResponse)
    }, 15000)
  }

  handleStudentOneTimeout = (endDTime, submitSelections, putResponse) => {
    getChoiceLines(this.state.selectedChoiceLine)
      .then(getChoiceLinesResponse => {
        let selectionAppearedOnStudyPlan = getChoiceLinesResponse.choiceLine.selections
          .map(choiceLineSelections => choiceLineSelections.selections)
          .flatMap(selections => selections)
          .filter(selection => putResponse.checkOnStudyPlan.includes(selection.studyPackageCode))
          .filter(selection => selection.onStudyPlan)
          .map(selection => selection.studyPackageCode)

        let filteredPutResponses =
          selectionAppearedOnStudyPlan.length === 0
            ? putResponse.responses
            : putResponse.responses.filter(response => !putResponse.checkOnStudyPlan.includes(response.error.studyPackageCode))

        if (selectionAppearedOnStudyPlan.length !== putResponse.checkOnStudyPlan.length && isAfter(endDTime, new Date())) {
          putResponse.responses = filteredPutResponses

          this.scheduleStudentOneTimeoutCall(endDTime, submitSelections, putResponse)
        } else {
          let errorMessage = this.produceErrorDiv(putResponse, submitSelections, selectionAppearedOnStudyPlan)
          this.setState({
            stillProgressingLoading: false,
            updatingChoiceLines: false,
            openChoiceLineModel: true,
            choiceLineResponse: getChoiceLinesResponse.choiceLine,
            choiceLineSelections: submitSelections.filter(selection => !selectionAppearedOnStudyPlan.includes(selection.studyPackageCode)),
            displayError: errorMessage !== null,
            errorMessage: errorMessage
          })
        }
      })
      .catch(reason => {
        alert('An error has occurred while retrieving choice line, please try again.')
        this.setState({
          stillProgressingLoading: false,
          openChoiceLineModel: true,
          choiceLineSelections: [],
          displayError: true,
          errorMessage: this.produceErrorDiv(putResponse.responses, submitSelections, null)
        })
      })
  }

  produceErrorDiv = (putResponse, submitSelections, selectionAppearedOnStudyPlan) => {
    let errorMessages = []
    if (putResponse.status === 504) {
      let unprocessedSelections = submitSelections.filter(selection => !selectionAppearedOnStudyPlan.includes(selection.studyPackageCode))
      if (unprocessedSelections.length > 0) {
        putResponse.responses.map(response => {
          if (response.error.apiCode !== 'PUT_CHOICELINES_REQUEST_005' && response.error.apiCode !== 'PUT_CHOICELINES_REQUEST_006') {
            if (unprocessedSelections.includes(response.studyPackageCode)) {
              unprocessedSelections.splice(unprocessedSelections.indexOf(response.studyPackageCode), 1)
            }

            errorMessages.push(React.createElement('div', {}, parse(response.error.apiMessage)))
          }
        })

        if (unprocessedSelections.length > 0) {
          let baseMessage = 'There was a problem processing your selection'
          if (unprocessedSelections.length > 1) {
            baseMessage += 's'
          }

          unprocessedSelections.forEach(function(element, index) {
            baseMessage += ' ' + element.studyPackageCode

            if (unprocessedSelections.length - 1 !== index) {
              if (unprocessedSelections.length - 2 !== index) {
                baseMessage += ','
              } else {
                baseMessage += ' and'
              }
            }
          })

          baseMessage += ', Please try again. If the problem persists, please '

          let link = React.createElement('a', { href: 'https://www.vu.edu.au/contact-us/vuhq-student-service-centres' }, 'contact VUHQ.')
          errorMessages.unshift(React.createElement('div', {}, baseMessage, link))
        }
      }
    } else {
      putResponse.responses.map(response => {
        errorMessages.push(React.createElement('div', {}, parse(response.error.apiMessage)))
      })
    }
    return errorMessages.length > 0 ? React.createElement('div', {}, errorMessages) : null
  }

  handleChoiceLineSubmit = (userSelections = []) => {
    let submitSelections = userSelections.filter(selection => selection.studentStudyPackageAttempt < 1 && !selection.onStudyPlan)

    let data = {
      choiceLine: {
        parentStudentStudyPackageNumber: this.state.selectedChoiceLine.parentStudentStudyPackage,
        studentStudyPackageNumber: this.state.selectedChoiceLine.studentStudyPackage,
        selections: submitSelections,
        rules: this.state.choiceLineResponse.rules
      }
    }

    this.setState({
      openChoiceLineModel: false,
      updatingChoiceLines: true,
      displayError: false,
      triggerReloadChoiceLineParents: false
    })

    putChoiceLines(data)
      .then(result => {
        this.setState({
          updatingChoiceLines: false,
          choiceLineSelections: [],
          triggerReloadChoiceLineParents: false
        })
        this.props.reloadChoiceLineParents()
      })
      .catch(error => {
        let putResponse = error.response.data

        if (error.response.status === 504 && putResponse !== null && putResponse !== undefined && putResponse.length <= 0) {
          putResponse = []
          putResponse['checkOnStudyPlan'] = selection.studyPackageCode
          putResponse['responses'] = []
        }

        if (putResponse.checkOnStudyPlan.length > 0) {
          this.setState({
            stillProgressingLoading: true,
            updatingChoiceLines: false,
            triggerReloadChoiceLineParents: true
          })
          let endDTime = new Date()
          endDTime = new Date(endDTime.getTime() + 120000)
          this.handleStudentOneTimeout(endDTime, submitSelections, putResponse)
        } else {
          this.setState({
            openChoiceLineModel: true,
            choiceLineSelections: userSelections,
            updatingChoiceLines: false,
            displayError: true,
            errorMessage: this.produceErrorDiv(error.response.data, submitSelections, null)
          })
        }
      })
  }

  handleCancel = () => {
    if (this.state.triggerReloadChoiceLineParents) {
      this.props.reloadChoiceLineParents()
    }
    this.setState({
      openChoiceLineModel: false,
      displayError: false,
      errorMessage: null,
      triggerReloadChoiceLineParents: false
    })
  }

  handleChoiceLineModelOpen = choiceLine => {
    this.setState({
      loadingWholePage: true
    })

    getChoiceLines(choiceLine)
      .then(getChoiceLinesResponse => {
        this.setState({
          loadingWholePage: false,
          openChoiceLineModel: true,
          choiceLineResponse: getChoiceLinesResponse.choiceLine,
          selectedChoiceLine: choiceLine,
          choiceLineSelections: []
        })
      })
      .catch(reason => {
        alert('An error has occurred while retrieving choice line, please try again.')
        this.setState({
          loadingWholePage: false,
          openChoiceLineModel: false
        })
      })
  }

  renderChoiceLineInformation = () => {
    let hasDisplayChoiceLine = true
    let choiceLinesOptionsDiv = []
    let rightColumn = null
    let link = null

    this.props.choiceLines.forEach((choiceLine, index) => {
      rightColumn = null
      link = null
      if (choiceLine.displayChoiceLine) {
        if (choiceLine.advancedStandingApplied) {
          link = helpContactButtonLink()
        } else if (!choiceLine.selectionRequired) {
          link = React.createElement('button', { className: 'btnBasic btn-secondary pd12 fs14 fwBold', onClick: () => this.handleChoiceLineModelOpen(choiceLine)}, 'Review selection')
        } else if (choiceLine.selectionRequired) {
          link = React.createElement('button', { className: 'btnBasic btn-primary pd12 fs14 fwBold', onClick: () => this.handleChoiceLineModelOpen(choiceLine)}, 'Select')
        }

        rightColumn = React.createElement('div', { className: 'col-xs-12 col-md-4 pl0 pr0', key: 'column-' + index}, link)
      } else {
        hasDisplayChoiceLine = false
      }

      choiceLinesOptionsDiv.push(
        React.createElement(
          'div',
          { className: 'row mb5 bg-e4f5ff', key: 'choiceline-' + index },
          React.createElement('div', { className: 'col-xs-12 col-md-8 pl1rem pr0 displayFlexAlignCenter fs12 fwBold textTranformationFirstLetterUppercase' }, choiceLine.choiceDescription.toLowerCase()),
          rightColumn
        )
      )
    })
    link = helpLink()

    let choiceLinesDiv = []

    if (!hasDisplayChoiceLine) {
      choiceLinesDiv.push(
        React.createElement(
          'div',
          { className: 'row mb32 fs14', key: 'no-choice-line' },
          'Contact your ',
          link,
          ' for assistance with your option selection. Once the selection has been made for you' +
            ' by a staff member, you can return here to manage your unit enrolments for the selected option.'
        )
      )
    } else {
      let lt = (<span>
        Please contact your {link} if you require assistance with your option selection(s).
        </span>)
      choiceLinesDiv.push(React.createElement('div', { className: 'row mb32 fs12', key: 'assist-link' }, lt))
    }

    return choiceLinesDiv.concat(choiceLinesOptionsDiv)
  }

  handleChoiceLineHelpModel = () => {
    this.setState({
      showChoiceLineHelpModel: false
    })
  }

  render() {
    // if (this.state.loadingWholePage) {
    //   return
    // }

    if (!this.props.choiceLines || (this.props.choiceLines && this.props.choiceLines.length <= 0)) {
      return null
    }

    return (
      <Sidenote className="sidenote--lochmara">
        {this.state.loadingWholePage && <LoadingWholePage />}
        {this.state.stillProgressingLoading && <LoadingWholePage message={"Still processing… please wait and don’t refresh the page.'"} />}
        {this.state.updatingChoiceLines && <LoadingWholePage message={'Your selection is being processed. This may take a minute, please wait.'} />}
        {this.state.removingChoiceLine && <LoadingWholePage message={'Your selection is being removed. This may take a minute, please wait.'} />}
        <div className="pd24">
          <div className='row mb16'>
            <strong>As part of your course progression, choose one or more options from below:</strong>
          </div>
          
          {this.renderChoiceLineInformation()}
          {this.state.openChoiceLineModel && (
            <ChoiceLineModel
              handleCancel={this.handleCancel}
              handleChoiceLineSubmit={this.handleChoiceLineSubmit}
              handleChoiceLineRemoval={this.handleChoiceLineRemoval}
              openChoiceLineModel={this.state.openChoiceLineModel}
              choiceLineResponse={this.state.choiceLineResponse}
              choiceLineSelections={this.state.choiceLineSelections}
              selectedChoiceLine={this.state.selectedChoiceLine}
              displayError={this.state.displayError}
              errorMessage={this.state.errorMessage}
            />
          )}
        </div>
      </Sidenote>
    )
  }
}

export default ChoiceLines
